<template>
  <BModal
    id="modal-warning"
    ref="modal-warning"
    no-stacking
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    size="md"
    hide-header
  >
    <div class="flex flex-col items-center gap-8">
      <div class="text-black text-xl font-semibold">
        Verifikasi Identitas
      </div>
      <img
        :src="metaMessage === 'dukcapil' ? 'https://storage.googleapis.com/komerce/assets/svg/Icon-Error.svg' : 'https://storage.googleapis.com/komerce/assets/svg/Icon-Warning.svg'"
        alt="Komerce"
      >
      <div class="text-[#333333]">
        {{ metaMessage === 'dukcapil'? 'Identitas KTP Tidak Sesuai dengan Data Dukcapil' : 'Identitas KTP Tervalidasi Sesuai dengan Data Dukcapil' }}
      </div>
      <span
        v-if="metaMessage === 'monit'"
        class="text-black font-semibold"
      >
        KTP sudah terdaftar di Monit
      </span>
      <BButton
        variant="primary"
        @click="$refs['modal-warning'].hide()"
      >
        {{ metaMessage === 'dukcapil'? 'Tutup': 'Kembali' }}
      </BButton>
    </div>
  </BModal>
</template>

<script>
export default {
  props: {
    metaMessage: {
      type: String,
      default: '',
    },
  },
}
</script>
